import styled from '@emotion/styled';
import { Box } from '~Styles';
import { handyBreakpoint } from '~Styles/breakpoints';

export const BoxWrapper = styled(Box)`
  width: 764px;

  ${handyBreakpoint} {
    width: 100%;
  }
`;

export const StyledBox = styled(Box)<{ background?: string }>`
  background-color: ${({ background }) => background || 'var(--colorBlueGray1100)'};
  border-radius: 8px;

  ${handyBreakpoint} {
    padding: 12px 16px;

    h3 {
      font-size: 16px;
    }

    h4 {
      font-size: 14px;
    }
  }
`;

export const StatBox = styled(Box)<{ borderColor?: string }>`
  padding: 8px 0;
  border-bottom: 1px solid ${({ borderColor }) => borderColor || 'var(--colorBlueGray1000)'};
  &:last-child {
    border-bottom: none;
  }
`;

export const ActivityStatBox = styled(Box)`
  background: var(--colorBlueGray1100);
  border-radius: 8px;
  white-space: nowrap;

  ${handyBreakpoint} {
    padding: 8px;

    h3 {
      font-size: 16px;
    }
  }
`;
